// src/utils/socket.js
import Pusher from 'pusher-js';

let pusherInstance;

export const initializePusher = () => {
    if (!pusherInstance) {
        pusherInstance = new Pusher('fd21c323aa7a354745b6', {
            cluster: 'ap2',
            encrypted: true,
            enabledTransports: ['ws', 'wss'],
            forceTLS: true,
        });

        // Add connection event listeners for debugging
        pusherInstance.connection.bind('connected', () => {
        });

        pusherInstance.connection.bind('disconnected', () => {
        });

        pusherInstance.connection.bind('error', (err) => {
            console.error('❌ Pusher connection error:', err);
        });

        pusherInstance.connection.bind('state_change', (states) => {
        });
    }
    return pusherInstance;
};

export const getPusherInstance = () => {
    if (!pusherInstance) {
        throw new Error('Pusher has not been initialized. Call initializePusher() first.');
    }
    return pusherInstance;
};
